import { PAGE_SIZES } from '@/common/constant'

export default {
  data() {
    return {
      paginPageSizes: PAGE_SIZES
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js